import React, { useState, useEffect } from 'react'
import { Button } from "baseui/button";
import { Heading, HeadingLevel } from 'baseui/heading';
import { useNavigate } from "react-router-dom";
import { Card } from "baseui/card";
import { UserContext } from '../App';
import InputBox from '../components/InputBox';
import HeadingSection from '../components/Heading';
import { Checkbox, STYLE_TYPE, LABEL_PLACEMENT } from "baseui/checkbox";
import { getPaymentConnectorCreateData } from '../utils/data';
import { useSnackbar } from 'baseui/snackbar';
import { baseUrl, getHeader } from '../utils/consts';

const AccountRetrive = () => {
    const { enqueue } = useSnackbar();
    const [isLoading, setIsLoading] = useState(false);
    let navigate = useNavigate();
    let { uid, orcaAPIKey, selectedPgs, setValue } = React.useContext(UserContext);
    const [localPGList, setLocalPGList] = useState([...selectedPgs]);

    useEffect(() => {
        console.log(selectedPgs)
        setLocalPGList([...selectedPgs])
    }, [selectedPgs])

    const paymentGateways = [
        "Stripe",
        "Adyen",
        "Checkout",
        "Authorizedotnet"
    ]

    const setMessage = (message, bgColor) => {
        enqueue({
            message: message,
            overrides: {
                Root: { style: { width: 'auto', backgroundColor: bgColor } },
            }
        })
    }

    let createPaymentConnectors = () => {
        setIsLoading(true)
        localPGList.map(pgName => {
            fetch(`${baseUrl}/account/${uid}/connectors`, {
                method: 'POST',
                headers: getHeader('test_admin'),
                body: getPaymentConnectorCreateData(pgName)
            })
                .then((res) => {
                    if (res.status !== 200) {
                        res.text().then(val =>
                            console.log("Network Error:-", JSON.parse(val).error.message)
                        )
                        setMessage("Cound't Get the Response", "red")
                        setIsLoading(false)
                        return;
                    } else {
                        setIsLoading(false)
                        navigate("/payment-gateways");
                    }
                }
                ).catch(err => {
                    console.log("ERROR:- ", err.message)
                    setIsLoading(false)
                });
        })
    }

    const onConfirmClicked = () => {
        setValue("selectedPg", localPGList[0])
        setValue("selectedPgs", localPGList)
        createPaymentConnectors()
    }

    return (
        <div style={{ height: "590px" }} className='w-full max-w-3xl mx-auto' >
            <Card>
                <div className='p-5' >
                    <HeadingSection iconEnabled={true} headerClass="mb-10" title={"Merchant connector account setup"} backUrl={"/"} />
                    <div className='flex gap-10' >
                        <div className='w-full' >
                            <HeadingLevel>
                                <div className='flex align-middle relative mb-5' >
                                    <Heading styleLevel={6}>Your Account Details</Heading>
                                </div>
                            </HeadingLevel>
                            <InputBox label={"Orca merchant ID"} value={uid} readOnly={true} placeholder="Orca merchant ID" />
                            <InputBox label={"Orca API Key"} value={orcaAPIKey} readOnly={true} placeholder="Orca API Key" />
                        </div>
                        <div className='border-l-2 my-2' />
                        <div className='w-full' >
                            <HeadingLevel>
                                <div className='flex align-middle relative mb-5' >
                                    <Heading styleLevel={6}>Enable payment processors</Heading>
                                </div>
                            </HeadingLevel>
                            <div className='pr-10' >
                                {
                                    paymentGateways.map(item => (
                                        <div key={item} className='font-medium flex justify-between my-3' >
                                            <div>{item}</div>
                                            <Checkbox
                                                checked={localPGList.includes(item)}
                                                checkmarkType={STYLE_TYPE.toggle}
                                                onChange={_ => {
                                                    if (localPGList.includes(item)) {
                                                        setLocalPGList(localPGList.filter(el => item !== el))
                                                    } else {
                                                        setLocalPGList([...localPGList, item])
                                                    }
                                                }}
                                                labelPlacement={LABEL_PLACEMENT.right}
                                            />
                                        </div>
                                    ))
                                }

                            </div>
                        </div>
                    </div>
                    <div className='mt-5' >
                        <Button style={{ width: "100%" }} disabled={!(localPGList.length > 0)} isLoading={isLoading} onClick={onConfirmClicked}>Confirm</Button>
                    </div>
                </div>
            </Card>
        </div>
    )
}

export default AccountRetrive